import normalizedSearchString from "./normalizedSearchString";

export default function includesSearch(searchString, searchValue) {
  return normalizedSearchString(searchString).includes(normalizedSearchString(searchValue));
}